@for (bundleOption of bundleOptions; track $index; let i = $index; let isFirst = $first) {
<div class="flex p-a-2 bg-col-5"
     [class.m-t-2]="!isFirst">
    <div class="w-2 p-r-3 _image">
        @if (getSelectedProduct(i)?.data?.image) {
        <div class="ratio-3-4 w-12 fade-animation overflow-hidden">
            <shell></shell>
            <img class="rf"
                 [image]="getSelectedProduct(i)!.data!.image">
        </div>
        }
    </div>
    <div class="w-10">
        <div class="flex flex-justify-between p-b-2">
            @if (getSelectedProduct(i)?.data?.name) {
            <p class="p2 truncate">
                {{ getSelectedProduct(i)!.data!.name }}
            </p>
            }
            <div class="p-l-2 no-wrap">
                <p class="p2"
                   *ifTradeStore>
                    <span class="col-12">{{ 'Quantity' | translate }}:</span> {{ getSelectedProductQty(i) }}
                </p>
                <ng-container *ifNotTradeStore>
                    <!-- org price for discount -->
                    @if (getSelectedProduct(i)?.orgPrice) {
                    <price class="inline-block m-r-2 col-12 va-m line-through s2 price"
                           [value]="getSelectedProduct(i)!.orgPrice"></price>
                    }
                    <!-- final price -->
                    <price class="inline-block va-m s2 price"
                           [value]="getSelectedProduct(i)?.price"></price>
                </ng-container>
            </div>
        </div>
        <!-- X, L / listing filters -->
        <p [tradeClass]="'m-t-1'">
            @for (filter of getListingFilters(i); track $index; let isFirst = $first; let
            isLast = $last) {
            <product-bundle-options-attribute [class.w-12]="filter.optionsWithMatches.length > 1"
                                              [filter]="filter"
                                              [product]="getSelectedProduct(i)"
                                              [defaultOption]="defaultFilterSelection(bundleOption, filter.id)"
                                              (hoveredColor)="changeColorOnHover($event, i)"
                                              [isFirst]="isFirst">
            </product-bundle-options-attribute>
            }
        </p>
    </div>
</div>
}